import axiosInstance from './axiosInstance';

export const getCommissionDetail = (salesId) =>
    axiosInstance.get(`/CommissionAmendment/GetCommissionDetail?salesId=${salesId}`);

export const createAmendment = (request) =>
    axiosInstance.post("/CommissionAmendment/CreateAmendment", request);

export const approveAmendment = (amendmentId) =>
    axiosInstance.put("/CommissionAmendment/ApproveAmendment", { amendmentId });

export const rejectAmendment = (amendmentId, remarks) =>
    axiosInstance.put("/CommissionAmendment/RejectAmendment", { amendmentId, remarks });

export const getPendingAmendments = () =>
    axiosInstance.get("/CommissionAmendment/GetPendingAmendments");
